import types from "../actions/actionTypes";
import initialState from "./initialState";


export default function projectTypesReducer(state = initialState.projectTypesList, action) {

    switch (action.type) {
        case types.LOAD_PROJECTTYPES_SUCCESS:
            return action.projectTypesList;       
        default:
            return state;
    }
}

